import styled, { css } from 'styled-components';
import StepsBase, { Step as CustomStep } from 'rc-steps';
import { transparentize } from 'polished';
import 'rc-steps/assets/index.css';
import { pulse } from 'styles/animation';
import { Container as ContainerFlag } from 'components/Flag/styles';
import { Form as FormBase } from '@unform/web';
interface StepProps {
  id: string;
  next: string;
  status: string;
}
export const Container = styled.div`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
  }
`;

export const Lista = styled.ul`
  caret-color: transparent;
`;

export const Item = styled.li`
  display: flex;
  flex-direction: row;
  padding: 15px 0 5px;

  border-bottom: 1px solid
    ${props => transparentize(0.6, props.theme.fontColor)};
  &:last-of-type {
    border-bottom: none;
  }
`;

export const Dados = styled.div`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  span {
    padding: 3px 0px;
    display: flex;
    font-size: 0.975rem;
    align-items: center;

    p {
      width: 120px;
      font-size: 0.975rem;
      margin-right: 5px;
      font-weight: 400;
    }
    strong {
      font-weight: 400;
    }
    ${ContainerFlag} {
      margin-left: 5px;
      &:first-of-type {
        margin-left: 0;
      }
    }
  }
`;

export const Steps = styled(StepsBase)`
  display: flex;
  flex: 1.5 1.5;
  width: auto !important;
  align-items: center;
`;

export const Step = styled(CustomStep)<StepProps>`
  .rc-steps-item-title {
    color: ${props => props.theme.fontColor} !important;
    font-weight: 400 !important;
  }
  .rc-steps-item-container {
    margin-left: -2px !important;
  }
  .rc-steps-item-icon {
    span {
      font-size: 28px !important;
      svg {
        stroke-width:${props =>
          props.theme.name === 'light'
            ? '2.3px !important;'
            : '1.3px !important;'};
        size: 30px !important;

      }
    }
  }

  .rc-steps-item-tail {
    &:after {
      height: 3px !important;
      border-radius: 10px !important;
    }
  }

  ${props =>
    props.status === 'finish' &&
    css`
      .rc-steps-icon {
        color: ${props => props.theme.button.success.out} !important;
      }
      .rc-steps-item-tail {
        ${props.next === 'wait' &&
          css`
            &:after {
              background: linear-gradient(
                90deg,
                ${props => props.theme.button.success.out} 30%,
                ${props => props.theme.button.primary.in} 100%
              );
            }
          `}
        &:after {
          background-color: ${props =>
            props.theme.button.success.out} !important;
        }

        ${props.next === 'error' &&
          css`
            &:after {
              background: linear-gradient(
                90deg,
                ${props => props.theme.button.success.out} 30%,
                ${props => props.theme.button.danger.in} 100%
              );
            }
          `}
        &:after {
          background-color: ${props =>
            props.theme.button.success.out} !important;
        }
      }
    `}

  ${props =>
    props.status === 'process' &&
    css`
      .rc-steps-item-tail {
        &:after {
          background: linear-gradient(
            90deg,
            ${props => props.theme.button.primary.in} 10%,
            ${props => props.theme.loadingTableColor} 50%
          );
        }
      }
    `}

    ${props =>
      props.status === 'error' &&
      css`
        .rc-steps-item-tail {
          &:after {
            background: linear-gradient(
              90deg,
              ${props => props.theme.button.danger.in} 10%,
              ${props => props.theme.loadingTableColor} 50%
            );
          }
        }
      `}


    ${props =>
      props.status === 'wait' &&
      css`
        .rc-steps-icon {
          color: ${props => props.theme.loadingTableColor} !important;
        }
        .rc-steps-item-tail {
          &:after {
            background-color: ${props =>
              props.theme.loadingTableColor} !important;
          }
        }
      `}
`;

export const Alert = styled.div`
  display: flex;
  align-items: center;
  svg {
    font-size: 28px;
    fill: ${props => props.theme.warn};
    z-index: 2;
  }
  position: relative;

  transform-origin: 50% 50%;
  animation-duration: 1.7s;
  animation-name: ${pulse};
  animation-iteration-count: 3;
`;

export const Acoes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    opacity: 0.8;
  }
`;

export const Form = styled(FormBase)`
  align-items: baseline;
  display: flex;
  justify-content: flex-end;
  width: 403px;
`;
